import { useNavigate } from 'react-router';
import { OrganizationApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { EditHolidayDto } from '../../../commonTypes/organization.types';
import { useTranslation } from '../../useTranslation';

const useHttpPatchHoliday = () => {
    const { t } = useTranslation('newNotifications');
    const navigate = useNavigate();
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (id: string, body: EditHolidayDto, callback: { onSuccess?: (data: any) => void }): Promise<any> => {
        return new Promise((resolve, reject) => {
            const { exec } = organizationApi.editHoliday({
                params: { id },
                body: body,
                onSuccess: response => {
                    const { overlappingUsers } = response.body;

                    if (overlappingUsers && overlappingUsers.length > 0) {
                        if (callback.onSuccess) callback.onSuccess(overlappingUsers);
                        resolve(overlappingUsers);
                    } else {
                        if (callback.onSuccess) callback.onSuccess(response.body);
                        toastHandler.push('success', t('holiday.updateHolidayTitle'), t('holiday.updateHolidayMessage_Success'));
                        navigate(`/holidays`);
                        resolve(response.body);
                    }
                },
                onError: error => {
                    toastHandler.push('error', t('holiday.updateHolidayTitle'), t('holiday.updateHolidayMessage_Failed'));
                    reject(error);
                },
            });
            exec();
        });
    };

    return {
        exec,
    };
};

export default useHttpPatchHoliday;
